import React from "react";
import T from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { BOOKMARKS } from "MODULES/users/constants";
import { isArray } from "lodash";

import { dismissibleChild } from "MODULES/shared/decorators";
import Item from "./Item";
import { destroy } from "./actions";

class BookmarkedParts extends React.Component {
  renderItem = (item, i) => {
    const { pushHistory, removeItem } = this.props;

    return (
      <Item
        item={item}
        key={`bookmark-item-${i}`}
        destroy={removeItem}
        pushHistory={pushHistory}
      />
    );
  };

  render() {
    const { bookmarks, visible, toggle, contentRef } = this.props;

    if (bookmarks.length === 0) return null;

    const totalCount = bookmarks.length;

    const classes = classNames("navbar-dropdown-icon bookmarks pointer", {
      open: visible
    });

    const sortedBookmarks = bookmarks.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    return (
      <li className={classes} ref={contentRef} id="bookmarks">
        <a
          className="dropdown-toggle"
          role="button"
          onClick={toggle}
          aria-expanded="false"
        >
          <i className="fa fa-fw fa-lg fa-bookmark" />
          <span className="hidden-md hidden-lg">&nbsp;Bookmarks</span>
          <span className="badge">{totalCount}</span>
        </a>
        <ul className="dropdown-menu" role="menu">
          {sortedBookmarks.map(this.renderItem)}
        </ul>
      </li>
    );
  }
}

export default connect(
  state => {
    const bookmarks = state.session.get(BOOKMARKS).toJS();
    return {
      bookmarks: isArray(bookmarks) ? bookmarks : []
    };
  },
  dispatch => ({
    removeItem: id => dispatch(destroy(id)),
    pushHistory: id => dispatch(push(`/parts/${id}`))
  })
)(dismissibleChild(BookmarkedParts));

BookmarkedParts.propTypes = {
  bookmarks: T.arrayOf(T.shape({})),
  contentRef: T.node,
  removeItem: T.func,
  pushHistory: T.func,
  toggle: T.func,
  visible: T.bool
};



// WEBPACK FOOTER //
// ./app/Nav/BookmarkedParts/BookmarkedParts.jsx